import React from "react";
import { connect } from "react-redux";
import EducationDetail from "../../../../Profile/Home/ProfileInformation/Education/EducationDetail";
import getMemberEducationProfile from "../../../../../_selectors/profileSelectors/getMemberEducationProfile";
import getMemberIncome from "../../../../../_selectors/profileSelectors/getMemberIncome";
import { updateObject } from "../../../../../_utils";

const Education = ({ userProfile, showToast, income }) => {
  return (
    <EducationDetail
      userProfile={updateObject(userProfile, { income })}
      showEdit={false}
    />
  );
};

const mapStateToProps = (state, ownProps) => ({
  userProfile: getMemberEducationProfile(state),
  income: getMemberIncome(state)
});

export default connect(mapStateToProps)(Education);



// WEBPACK FOOTER //
// ./src/_components/ViewProfile/Profile/ProfileInformation/Education/index.js